import { render } from "./BackLogos.vue?vue&type=template&id=4124f3f2&scoped=true"
import script from "./BackLogos.vue?vue&type=script&lang=js"
export * from "./BackLogos.vue?vue&type=script&lang=js"

import "./BackLogos.vue?vue&type=style&index=0&id=4124f3f2&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4124f3f2"]])

export default __exports__